var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M372.7 299.3C375.8 302.4 379.9 304 384 304s8.188-1.562 11.31-4.688l64-64c6.25-6.25 6.25-16.38 0-22.62l-64-64c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62L425.4 224l-52.69 52.69C366.4 282.9 366.4 293.1 372.7 299.3zM267.3 148.7c-6.25-6.25-16.38-6.25-22.62 0l-64 64c-6.25 6.25-6.25 16.38 0 22.62l64 64C247.8 302.4 251.9 304 256 304s8.188-1.562 11.31-4.688c6.25-6.25 6.25-16.38 0-22.62L214.6 224l52.69-52.69C273.6 165.1 273.6 154.9 267.3 148.7zM80 352C88.84 352 96 344.8 96 336V96c0-17.66 14.36-32 32-32h384c17.64 0 32 14.34 32 32v240c0 8.844 7.156 16 16 16s16-7.156 16-16V96c0-35.28-28.7-64-64-64H128C92.7 32 64 60.72 64 96v240C64 344.8 71.16 352 80 352zM624 384h-608C7.25 384 0 391.3 0 400V416c0 35.25 28.75 64 64 64h512c35.25 0 64-28.75 64-64v-16C640 391.3 632.8 384 624 384zM576 448H64c-17.64 0-32-14.36-32-32h576C608 433.6 593.6 448 576 448z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopCode);
export default __webpack_public_path__ + "static/media/laptop-code.dd5cce1424c0aff8fe07c272fa0f2422.svg";
export { ForwardRef as ReactComponent };